export default __webpack_public_path__ + "static/media/Flag_of_Greece.225a7586.svg";